import { MaybeNull } from 'interfaces'

export const joinNonEmpty = (arr?: MaybeNull<string | number | undefined>[], separator = ' ') =>
  (arr || []).filter(item => item === 0 || !!item).join(separator)
